exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hub-semantic-drop-down.ui.dropdown>.dropdown.icon {\n    /*margin: 0 0 0 0.5em;*/\n    /*vertical-align: middle;*/\n}", ""]);
